<div class="alert-container" [ngClass]="data.type" role="status">
    <div class="icon-container">
        <mat-icon>{{ icon }}</mat-icon>
    </div>
    <div class="message-container">
        <span class="message-text">{{ data.message }}</span>
    </div>
    <div class="action-container">
        <button mat-icon-button type="button" aria-label="Dismiss notification" (click)="dismiss()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>